import {date, InferType,object, string} from 'yup';

import {getTodayAt0Hours} from '../../utils/date';
import {PHONE_NUMBER_REGEX} from '../../utils/validation';

const REQUIRED_FIELD_MESSAGE = 'This is a required field';

const oneYearFromNow = new Date();
oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);

export const GiftCardDataSchema = object({
  note: string().required(REQUIRED_FIELD_MESSAGE),
  recipientName: string().required(REQUIRED_FIELD_MESSAGE),
  recipientEmail: string()
    .email('Please enter a valid email address')
    .required(REQUIRED_FIELD_MESSAGE),
  recipientPhoneNumber: string()
    .matches(PHONE_NUMBER_REGEX, 'Please enter a valid Australian phone number')
    .required('This is a required field'),
  deliveryDate: date()
    .min(getTodayAt0Hours(), 'Delivery date cannot be in the past')
    .max(oneYearFromNow, 'Delivery date cannot be more than one year from now')
    .typeError('Please enter a valid date')
    .required(REQUIRED_FIELD_MESSAGE),
});

export type GiftCardData = InferType<typeof GiftCardDataSchema>;
